import ContentfulEntry from "./ContentfulEntry";
import ContentfulRichText from './ContentfulRichText'
import { get } from "lodash";

class ContentfulInformationPage {
    
	static default = {
		title: "",
		body: ""
	};

	static title = contentfulInformationPage => {
		const fields = ContentfulEntry.fields(contentfulInformationPage);
		const title = get(fields, "title", ContentfulInformationPage.default.title);
		return title;
	};

	static bodyHtml = contentfulInformationPage => {
		const fields = ContentfulEntry.fields(contentfulInformationPage);
        const body = get(fields, "body", ContentfulInformationPage.default.body);
        const bodyHtml = ContentfulRichText.toHtml(body)
		return bodyHtml;
	};
}

export default ContentfulInformationPage;
